namespace $.$$ {

	type Cell_id = { row : number[] , col : number }

	export class $shm_hitalama_map_widget_float_table extends $.$shm_hitalama_map_widget_float_table {
		
		@ $mol_mem
		rows() {
			const rows = this.widget().table().rows_limited() ?? []
			const head = this.table_head_rich()
			if( this.checkboxes_showed() ) return rows.map( (r, i) =>  [ false, i+1, ...r ] )
			return rows.map( (r, i) =>  [ i+1, ...r ] )
		}

		@ $mol_mem
		table_head_rich() {
			if( this.checkboxes_showed() ) return [ '', '', ... this.widget().table_head() ?? [] ]
			return [ '', ... this.widget().table_head() ?? [] ]
		}

		@ $mol_mem
		col_types() {
			if( this.checkboxes_showed() ) return [ 'check', 'index', ... this.widget().table_col_types() ?? [] ]
			return [ 'index', ... this.widget().table_col_types() ?? [] ]
		}

		deleting_tool_visible() {
			return this.col_types().includes( 'action_delete' ) ? super.deleting_tool_visible() : []
		}

		cell_delete_visible( id: Cell_id ) {
			return this.delete_enabled() ? super.cell_delete_visible(id) : []
		}

		Cell( id: Cell_id ) : $mol_view {

			const col_type = this.col_types()?.[id.col]
			if( col_type == 'check' ) return this.Cell_checkbox( id )
			if( col_type == 'index' ) return this.Cell_index_number( id )
			if( col_type == 'file' ) return this.Cell_file( id )
			if( col_type == 'action_delete' ) return this.Cell_delete( id )
			if( col_type == 'action_edit' ) return this.Cell_edit( id )

			return this.Cell_text( id )
		}

		col_ids() {
			return this.table_head_rich().map( (_,i) => i )
		}
		
		col_head_content( n: number ) {
			const col_type = this.col_types()?.[n]
			if( col_type == 'check' ) return [ this.All_check() ]
			return [ this.table_head_rich()?.[n] || '' ]
		}

		col_settings_title( n: number ) {
			return this.table_head_rich()?.[n] || this.col_types()?.[n] || ''
		}

		@ $mol_mem_key
		cell_index_number( id: Cell_id ) {
			return ( Number( id.row[1]! ) + 1 ).toString()
		}

		@ $mol_mem_key
		cell_content_text_str( id: Cell_id ) {
			return this.cell_content_text( id ).toString()
		}

		@ $mol_mem_key
		cell_file_name( id: Cell_id ) {
			const ref_str = this.cell_content_text_str( id )
			const file = $giper_baza_glob.Pawn( new $giper_baza_link( ref_str ), $shm_hitalama_file )
			return file.title()
		}

		@ $mol_mem_key
		cell_file_visible( id: Cell_id ) {
			const ref_str = this.cell_content_text_str( id )
			return ref_str ? super.cell_file_visible( id ) : []
		}

		@ $mol_mem_key
		file_uri_async( ref_str: string ) {
			const file = $giper_baza_glob.Pawn( new $giper_baza_link( ref_str ), $shm_hitalama_file )
			const blob = file.blob()!
			return this.$.$mol_blob_uri( blob )
		}

		@ $mol_action
		file_uri( ref_str: string ) {
			return this.$.$mol_wire_sync(this).file_uri_async( ref_str )
		}

		@ $mol_mem_key
		cell_file_uri( id: Cell_id ) {
			const ref_str = this.cell_content_text_str( id )
			const uri = this.file_uri( ref_str )
			return uri
		}

		@ $mol_mem_key
		cell_checked( id: Cell_id, next?: boolean ) {
			const checks = this.widget().table().Rows_checked(null)?.val() as Record< number, boolean >
			const row_i = id.row[1]!
			if( next === undefined ) return  checks?.[ row_i ] ?? false

			this.widget().table().Rows_checked(null)?.val( { 
				... checks,
				[row_i]: next,
			} )
			return next
		}

		@ $mol_action
		cell_delete( id: Cell_id ) {
			const row_i = id.row[1]!
			this.map().search_statistics_cut( row_i )

			const rows_checked = this.widget().table().Rows_checked()?.val() as Record< number, boolean > ?? {}
			const rows_checked_next: Record< number, boolean > = {}

			for (const key in rows_checked) {
				let n = Number(key)
				const bool = rows_checked[n]
				if( n > row_i ) n--
				rows_checked_next[n] = bool
			}

			this.widget().table().Rows_checked()?.val(rows_checked_next)
		}

		@ $mol_action
		cell_edit( id: Cell_id ) {
			const row_i = id.row[1]!
			const statistic = this.map().Search_statistics()?.remote_list().at( row_i )

			const pos = [
				this.widget().body_x() + this.widget().right_edge_x(),
				this.widget().body_y(),
			]

			const widget = this.map().widget_add( 'form_edit', pos, 450, 780 )
			widget?.Form_edit(null)?.remote( statistic )

			this.Map_page().contextmenu_showed( false )
		}

		cell_checkboxes() {
			const checkboxes = this.table_row_ids().map( row => this.Checkbox( { col: '0', row } ) )
			return checkboxes
		}

		@ $mol_mem_key
		col_width_px( id: any ) {
			const width = Number( this.col_width( id.col ) )
			return isNaN( width ) ? 'auto' : width + 'px'
		}

		@ $mol_mem_key
		col_width( col: any, next?: number ): number {
			const col_index = Number( col )
			const widths = this.widget().table()?.Col_widths()?.val() as readonly number[] | undefined
			if( next === undefined ) return widths?.[col_index] ?? NaN

			const widths_next = [ ... widths??[] ]
			widths_next[col_index] = next
			this.widget().table()?.Col_widths(null)?.val( widths_next )

			return next ?? NaN
		}

		@ $mol_mem
		col_width_rows() {
			return this.table_head_rich().slice(2).map( (_, i) => this.Col_width_row( i + 2 ) )
		}

		@ $mol_action
		chart_add() {
			const chart_pos = this.Map_page().contextmenu_real_pos()
			const chart_widget = this.map().widget_add( 'chart', chart_pos, 600, 400 )
			chart_widget?.Table(null)?.remote( this.widget().table() )
			const chart = chart_widget?.chart()
			chart?.Widget(null)?.remote( chart_widget )

			chart_widget?.settings_widget_enabled( true )

			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_action
		tabulator_add() {
			const pos = this.Map_page().contextmenu_real_pos()
			const widget = this.map().widget_add( 'tabulator', pos, 720, 420 )
			widget?.Table(null)?.remote( this.widget().table() )

			this.Map_page().contextmenu_showed( false )
		}

		@ $mol_action
		echarts_add() {
			const pos = this.Map_page().contextmenu_real_pos()
			const widget = this.map().widget_add( 'echarts', pos, 650, 460 )
			widget?.Table(null)?.remote( this.widget().table() )

			const chart = widget?.chart()
			chart?.Widget(null)?.remote( widget )

			widget?.settings_widget_enabled( true )

			this.Map_page().contextmenu_showed( false )
		}
		
	}

}
